import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { ReactElement, useState, useEffect } from 'react'
import { Collapse } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { I18n } from 'common'
import { defaultTheme } from '../../../../../src/theme/index'
import { Price } from '../../../../../src/ui-components/products/Price'
import styled from 'styled-components'
import { VehicleInfoProps } from '../../../../../src/features/SummaryPanel/Interfaces'
import MultiSellerServicesProvider, {
  ISeller,
} from '../../../../../src/services/MultiSellerServicesProvider'
import { useUiStateStore } from '../../../../../src/store/uiState/UiStateStore'

const OrderConfirmationVehicleInfo = (
  props: VehicleInfoProps
): ReactElement => {
  const {
    idToCollapse,
    anchorTag,
    vehicleName,
    locationsCostData,
    totalCost,
    showYourCost,
    vehicleSummary,
  } = props
  const [showItemPrice, setShowItemPrice] = useState(false)
  const [sellersData, setSellersData] = useState<ISeller[]>([])

  const uiStore = useUiStateStore()

  const handleOnClick = () => {
    setShowItemPrice(!showItemPrice)
  }

  // const scrollWithOffset = (el: HTMLElement) => {
  //   const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset
  //   // scroll up 320px for move to title card
  //   const yOffset = -320
  //   window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' })
  // }
  useEffect(() => {
    if (!uiStore?.isMultisellerUser()) {
      return
    }
    MultiSellerServicesProvider.getActiveSellers()
      .then((response) => {
        setSellersData(response)
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err)
      })
  }, [uiStore])

  function getSellerName(coverageKey: number | string | undefined): string {
    const match = sellersData?.find((item) => item.coverageKey === coverageKey)
    return match ? match.sellerName : coverageKey === '' ? 'MyPlace4Parts' : ''
  }
  return (
    <Wrapper>
      <Arrow
        onClick={handleOnClick}
        aria-controls={idToCollapse}
        aria-expanded={showItemPrice}
      >
        {!showItemPrice ? <StyledExpandMore /> : <StyledExpandLess />}
      </Arrow>
      <VehicleCartInfo>
        <VehicleModelInfo>
          <Link to={anchorTag} style={{ color: defaultTheme.colors.link }}>
            {vehicleName}
          </Link>
        </VehicleModelInfo>
        {uiStore?.isMultisellerUser() ? (
          <Collapse in={showItemPrice}>
            <ItemTotals id={idToCollapse}>
              {locationsCostData?.map((val) => (
                <VehicleNameWrapper key={`${val.coverageKey}`}>
                  <Column>
                    <SpaceBetweenRow>
                      <SellerTitle>
                        {getSellerName(val?.coverageKey)}
                      </SellerTitle>
                    </SpaceBetweenRow>
                    <SpaceBetweenRow>
                      <OrderConfirmationCost>
                        <I18n name="Items" />:
                      </OrderConfirmationCost>
                      <OrderConfirmationCost>
                        <Price num={val?.costSubTotal} />
                      </OrderConfirmationCost>
                    </SpaceBetweenRow>
                    {(val?.coreSubTotal ?? 0) > 0 && (
                      <SpaceBetweenRow>
                        <OrderConfirmationCost>
                          <I18n name="coreCost" />:
                        </OrderConfirmationCost>
                        <OrderConfirmationCost>
                          <Price num={val?.coreSubTotal} />
                        </OrderConfirmationCost>
                      </SpaceBetweenRow>
                    )}
                    {(val?.bundleSavings ?? 0) > 0 && (
                      <SpaceBetweenRow>
                        <OrderConfirmationCost>
                          <I18n name="bundleSavings" />
                        </OrderConfirmationCost>
                        <OrderConfirmationCost>
                          - <Price num={val?.bundleSavings} />
                        </OrderConfirmationCost>
                      </SpaceBetweenRow>
                    )}
                    <SpaceBetweenRow>
                      <OrderConfirmationCost>
                        <I18n name="orderTotal" />:
                      </OrderConfirmationCost>
                      <OrderTotalTextWrapper>
                        <Price num={val?.orderTotal} />
                      </OrderTotalTextWrapper>
                    </SpaceBetweenRow>
                  </Column>
                </VehicleNameWrapper>
              ))}
              {(vehicleSummary?.laborCost ?? 0) > 0 && (
                <VehicleGrandTotal noMargin>
                  <I18n name="laborCost" />
                  <Price num={vehicleSummary?.laborCost} />
                </VehicleGrandTotal>
              )}
              {showYourCost && (
                <VehicleGrandTotal noMargin>
                  <I18n name="vehicleTotal" />
                  <Price num={totalCost} />
                </VehicleGrandTotal>
              )}
            </ItemTotals>
          </Collapse>
        ) : (
          <Collapse in={showItemPrice}>
            <ItemTotals id={idToCollapse}>
              {vehicleSummary?.locationSummary?.map((locationItem, index) => (
                <VehicleNameWrapper key={`${locationItem?.location}-${index}`}>
                  <Column>
                    <SpaceBetweenRow>
                      <OrderConfirmationCost>
                        <I18n name="Items" />:
                      </OrderConfirmationCost>
                      <OrderConfirmationCost>
                        <Price num={locationItem?.itemsCost} />
                      </OrderConfirmationCost>
                    </SpaceBetweenRow>
                    {(locationItem?.coreCost ?? 0) > 0 && (
                      <SpaceBetweenRow>
                        <OrderConfirmationCost>
                          <I18n name="coreCost" />:
                        </OrderConfirmationCost>
                        <OrderConfirmationCost>
                          <Price num={locationItem?.coreCost} />
                        </OrderConfirmationCost>
                      </SpaceBetweenRow>
                    )}
                    {(locationItem?.bundleSavings ?? 0) > 0 && (
                      <SpaceBetweenRow>
                        <OrderConfirmationCost>
                          <I18n name="bundleSavings" />
                        </OrderConfirmationCost>
                        <OrderConfirmationCost>
                          - <Price num={locationItem?.bundleSavings ?? 0} />
                        </OrderConfirmationCost>
                      </SpaceBetweenRow>
                    )}
                    {(vehicleSummary?.laborCost ?? 0) > 0 && (
                      <SpaceBetweenRow>
                        <OrderConfirmationCost>
                          <I18n name="laborCost" />
                        </OrderConfirmationCost>
                        <OrderConfirmationCost>
                          <Price num={vehicleSummary?.laborCost ?? 0} />
                        </OrderConfirmationCost>
                      </SpaceBetweenRow>
                    )}
                    <SpaceBetweenRow>
                      <OrderConfirmationCost>
                        <I18n name="orderTotal" />:
                      </OrderConfirmationCost>
                      <OrderTotalTextWrapper>
                        <Price num={vehicleSummary?.vehicleTotalCost ?? 0} />
                      </OrderTotalTextWrapper>
                    </SpaceBetweenRow>
                  </Column>
                </VehicleNameWrapper>
              ))}
            </ItemTotals>
          </Collapse>
        )}
      </VehicleCartInfo>
    </Wrapper>
  )
}

const VehicleCartInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  margin-bottom: 1rem;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
`

const VehicleModelInfo = styled.div`
  text-decoration: underline;
  color: ${defaultTheme.colors.link};
  margin-bottom: 0.2rem;
`

const Wrapper = styled.div`
  display: flex;
`

const SpaceBetweenRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const StyledExpandMore = styled(ExpandMore)`
  margin-top: -3px;
  margin-right: 10px;
  color: #0f172a;
  cursor: pointer;
`

const StyledExpandLess = styled(ExpandLess)`
  margin-top: -3px;
  margin-right: 10px;
  color: #0f172a;
  cursor: pointer;
`

const ItemTotals = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 400;
`

const Arrow = styled.div``

const SellerTitle = styled.h4`
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: ${defaultTheme.colors.text};
  mix-blend-mode: normal;
  text-align: left;
`
interface VehicleGrandTotalProps {
  noMargin?: boolean
}

const VehicleGrandTotal = styled.div<VehicleGrandTotalProps>`
  font-family: 'Roboto';
  font-weight: bold;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  margin-right: ${(p) => (p.noMargin ? '0px' : '2px')};
  margin-top: 10px;
`

const OrderTotalTextWrapper = styled.div`
  font-weight: 700;
  font-family: 'Roboto';
  font-size: 14px;
  line-height: 24px;
`
const VehicleNameWrapper = styled.div`
  margin-top: 18px;
`
const OrderConfirmationCost = styled.div``

export default OrderConfirmationVehicleInfo
